import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_PRODUCT_LIST: string = typeCreatorV2(
  'ProductReducer',
  'SetProductList'
);

export const INSERT_PRODUCT_FILTER: string = typeCreatorV2(
  'ProductReducer',
  'InsertProductFilter'
);

// export const SET_PAGE: string = typeCreatorV2('ProductReducer', 'SetPage');

export const SET_ADD_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SetAddProduct'
);

export const SET_SHARING_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SetSharingProduct'
);

export const ADD_TO_FAVOURITE: string = typeCreatorV2(
  'ProductReducer',
  'AddToFavourite'
);
export const REMOVE_FROM_FAVOURITE: string = typeCreatorV2(
  'ProductReducer',
  'RemoveFromFavourite'
);

export const SET_CATEGORY: string = typeCreatorV2(
  'ProductReducer',
  'SetCategory'
);

export const SET_FILTERS_SELECTION: string = typeCreatorV2(
  'ProductReducer',
  'SetFiltersSelection'
);

export const SET_POINT_SELECT: string = typeCreatorV2(
  'ProductReducer',
  'SetPointSelect'
);

export const SET_PARALIST: string = typeCreatorV2(
  'ProductReducer',
  'SetParalist'
);

export const SET_POI_LIST: string = typeCreatorV2(
  'ProductReducer',
  'SetPOIList'
);

export const SAVE_SEARCH: string = typeCreatorV2(
  'ProductReducer',
  'SaveSearch'
);

export const SET_ADD_POI: string = typeCreatorV2('ProductReducer', 'SetAddPOI');

export const SET_EDIT_POI: string = typeCreatorV2(
  'ProductReducer',
  'SetEditPOI'
);

export const SET_DELETE_POI: string = typeCreatorV2(
  'ProductReducer',
  'SetDeletePOI'
);

export const SET_SELECT_ADD_NEW: string = typeCreatorV2(
  'ProductReducer',
  'SetSelectAddNew'
);

// Task
export const SET_CUSTOMER_NAME: string = typeCreatorV2(
  'ProductReducer',
  'SetCustomerName'
);
export const SET_PROPERTY_NAME: string = typeCreatorV2(
  'ProductReducer',
  'SetPropertyName'
);
export const ADD_NEW_TASK: string = typeCreatorV2(
  'ProductReducer',
  'AddNewTask'
);
export const UPLOAD_FILE_TASK: string = typeCreatorV2(
  'ProductReducer',
  'UploadFileTask'
);
export const SET_STATUS_LANE: string = typeCreatorV2(
  'ProductReducer',
  'SetStatusLane'
);
// Favorite
export const SET_FAVORITES: string = typeCreatorV2(
  'ProductReducer',
  'SetFavoritesData'
);

export const SET_CUSTOMERS: string = typeCreatorV2(
  'ProductReducer',
  'SetCustomers'
);

export const SET_CLIENTS_MINI_PROFILES: string = typeCreatorV2(
  'ProductReducer',
  'SetClientMiniProfile'
);

export const SET_CUSTOMERS_BY_ROLE: string = typeCreatorV2(
  'ProductReducer',
  'SetCustomersByRole'
);

export const SET_ADD_ASSIGN_CLIENTS: string = typeCreatorV2(
  'ProductReducer',
  'SetAddAssignClients'
);

export const SET_ADD_COLLECTIONS: string = typeCreatorV2(
  'ProductReducer',
  'SetAddCollections'
);

export const SET_CLIENT_COLLECTION_PERSONAL: string = typeCreatorV2(
  'ProductReducer',
  'SetClientCollectionPersional'
);

export const SET_ADD_SHARING_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SetAddSharingProduct'
);

export const SET_ASSIGNESS: string = typeCreatorV2(
  'ProductReducer',
  'SetAssigness'
);

export const SET_LIST_VIEWED: string = typeCreatorV2(
  'ProductReducer',
  'SetListViewed'
);

export const SEND_EMAIL_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SendEmail'
);

export const SEND_EMAIL_ADVANCE_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SendEmailAdvance'
);

export const SEND_CLONE_PRODUCT: string = typeCreatorV2(
  'ProductReducer',
  'SendCloneProduct'
);

export const SET_PUBLISHED: string = typeCreatorV2(
  'ProductReducer',
  'SetPublished'
);

export const SET_COLLAPSE: string = typeCreatorV2(
  'ProductReducer',
  'SetCollapse'
);

export const DELETE_COLLECTION: string = typeCreatorV2(
  'ProductReducer',
  'DeleteCollection'
);

export const SET_POLYGON_DRAW: string = typeCreatorV2(
  'ProductReducer',
  'setPolygonDraw'
);

export const SET_ADD_CLIENT_REQUEST: string = typeCreatorV2(
  'ProductReducer',
  'SetAddClientRequest'
);

export const SET_GOOGLE_SEARCH_PLACE: string = typeCreatorV2(
  'ProductReducer',
  'SetGoogleSearchPlace'
);

export const GET_COLLECTION_BY_GUID: string = typeCreatorV2(
  'ProductReducer',
  'GetCollectionByGuid'
);

export const RESET_DATA_COLLECTION: string = typeCreatorV2(
  'ProductReducer',
  'ResetDataCollection'
);

export const SET_MAP_ZOOM_LEVEL: string = typeCreatorV2(
  'ProductReducer',
  'SetmapZoomLevel'
);

export const GET_LIST_POI_CATEGORY: string = typeCreatorV2(
  'ProductReducer',
  'GetListPoiCategory'
);

export const SET_ADD_POI_CATEGORY: string = typeCreatorV2(
  'ProductReducer',
  'SetAddPoiCategory'
);

export const SET_PRODUCT_DOCUMENT: string = typeCreatorV2(
  'ProductReducer',
  'SetProductDocument'
);

export const RESET_DOCUMENT: string = typeCreatorV2(
  'ProductReducer',
  'ResetDocument'
);

export const DELETE_PROPERTY_FROM_COLLECTION: string = typeCreatorV2(
  'ProductReducer',
  'DeltePropertyFromCollection'
);

export const SET_ASSIGN_CLIENTS_PRODUCTS: string = typeCreatorV2(
  'ProductReducer',
  'SetAssignClientsProducts'
);
